var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStockVariance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 19,
    viewBox: "0 0 64 64",
    width: 19,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m45.89 52a1 1 0 0 1 -1 .18l-4.53-1.69a1 1 0 0 0 -1.36.91v11.6h2v-10.16l3.19 1.16a3 3 0 0 0 3-.55l5.71-5a2.91 2.91 0 0 0 -.29-4.62 2.92 2.92 0 0 0 -3.24 0l-4.85 3.27-3.25-1.59a5.07 5.07 0 0 0 -2.2-.51h-3.76a6 6 0 1 0 -6.62 0h-3.76a5.07 5.07 0 0 0 -2.2.51l-3.25 1.59-4.86-3.23a2.92 2.92 0 0 0 -3.24 0 2.91 2.91 0 0 0 -.29 4.62l5.71 5a3 3 0 0 0 3 .55l3.2-1.2v10.16h2v-11.6a1 1 0 0 0 -1.35-.94l-4.53 1.69a1 1 0 0 1 -1-.18l-5.72-4.97a.88.88 0 0 1 -.31-.75.91.91 0 0 1 1.42-.7l5.34 3.54a1 1 0 0 0 1 .07l3.77-1.84a3 3 0 0 1 1.31-.32h5.71l-2.09 6.7a1 1 0 0 0 .1.83l2.5 4a1 1 0 0 0 1.7 0l2.5-4a1 1 0 0 0 .1-.83l-2.09-6.7h5.71a3 3 0 0 1 1.32.31l3.77 1.84a1 1 0 0 0 1-.07l5.34-3.54a.91.91 0 0 1 1.42.7.88.88 0 0 1 -.31.75zm-12.48 1.86-1.41 2.25-1.41-2.25 1.41-4.51zm-1.41-9.86a4 4 0 1 1 4-4 4 4 0 0 1 -4 4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m8 41h8a2 2 0 0 0 2-2v-8a2 2 0 0 0 -2-2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2zm0-10h3v2h2v-2h3v8h-8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m48 41h8a2 2 0 0 0 2-2v-8a2 2 0 0 0 -2-2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2zm0-10h3v2h2v-2h3v8h-8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m32 8a2 2 0 0 1 0 4 1 1 0 0 0 -1 1v3h2v-2.13a4 4 0 1 0 -5-3.87h2a2 2 0 0 1 2-2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m31 18h2v2h-2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m32 25a12 12 0 1 0 -12-12 12 12 0 0 0 12 12zm0-22a10 10 0 1 1 -10 10 10 10 0 0 1 10-10z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockVariance);
export default __webpack_public_path__ + "static/media/stockVariance.884cb5c982e5f8002f0d030394e86cc7.svg";
export { ForwardRef as ReactComponent };